/**
 * Application version information
 * Values are injected at build time via Vite's define config
 */

export const APP_VERSION = import.meta.env.VITE_APP_VERSION || 'dev';
export const BUILD_DATE = import.meta.env.VITE_BUILD_DATE;
export const ENVIRONMENT = import.meta.env.MODE;
export const GIT_COMMIT_SHA = import.meta.env.VITE_GIT_COMMIT_SHA;

/**
 * Format build date for display
 */
export function getFormattedBuildDate(): string {
  if (!BUILD_DATE) return 'Unknown';
  return new Date(BUILD_DATE).toLocaleString();
}

/**
 * Get short commit SHA (first 7 characters)
 */
export function getShortCommitSha(): string {
  if (!GIT_COMMIT_SHA) return 'Unknown';
  return GIT_COMMIT_SHA.substring(0, 7);
}

/**
 * Check if running in production
 */
export function isProduction(): boolean {
  return ENVIRONMENT === 'production';
}

/**
 * Get full version string with environment
 */
export function getFullVersionString(): string {
  const env = isProduction() ? '' : ` (${ENVIRONMENT})`;
  return `v${APP_VERSION}${env}`;
}
